import React, { Component } from "react";
import '../../assets/css/auth.css';
import logoBeta from "../../assets/img/logo-beta.png";
import { showNotificationGlobal } from "../../components/common/NotificationProvider";
import withNavigate from '../../components/withNavigate';
import { getYear } from "../../settings/shared/commonMethods";
import LoginService from "../../services/api/login";
import UserService from "../../services/api/user";
import { jwtDecode } from 'jwt-decode';
import { messages } from "../../settings/shared/CommonMessages";
import { ACCESS_TOKEN, API_RESPONSE, APP_VERSION, SIGNIN_AUTH_TOKEN } from "../../settings/shared/constants";
import {
    completeDesktopOAuth,
    isDesktopOAuth,
    preserveDesktopOAuthAcrossClear,
} from "../../settings/shared/desktopOAuth";
import slideWorkflow from "../../assets/img/slide-workflow.png";
import slideAgents from "../../assets/img/slide-agents.png";
import slideGateway from "../../assets/img/slide-gateway.png";
import slidePolicy from "../../assets/img/slide-policy.png";

const HERO_TITLE = "Secure Your Account With Two-Factor Authentication";
const HERO_DESCRIPTION = "Enter the verification code sent to your email to complete the authentication process and keep your account secure.";

const SLIDES = [
    { image: slideWorkflow, label: "Agent Workflow Builder" },
    { image: slideAgents,   label: "Agents in Action" },
    { image: slideGateway,  label: "LLM Gateway" },
    { image: slidePolicy,   label: "Policy Engine" },
];

// How long each slide stays in front before the carousel rotates (ms)
const SLIDE_INTERVAL = 5000;

class OTPVerification extends Component {
    constructor(props) {
        super(props);
        this.state = {
            otp: ['', '', '', '', '', ''],
            timer: 60,
            canResend: false,
            isLoading: false,
            email: this.props.location?.state?.email || '',
            turn: 0,
            paused: false,
        };
        this.slides = SLIDES;
        this.stageRef = React.createRef();
        this.otpInputRefs = [];
    }

    componentDidMount() {
        this.checkAuth();
        // Start timer
        this.startTimer();
        // rotate the showcase carousel (pauses while the pointer is over it)
        this.autoTimer = setInterval(() => {
            if (!this.state.paused) this.goToNext();
        }, SLIDE_INTERVAL);
        let states = null;
        if (window.history.state?.usr) {
            states = window.history.state.usr;
        }
        this.setState({
            email: states?.email || '',
        })
        // Focus first input
        if (this.otpInputRefs[0]) {
            this.otpInputRefs[0].focus();
        }
    }

    componentWillUnmount() {
        if (this.timerInterval) {
            clearInterval(this.timerInterval);
        }
        clearInterval(this.autoTimer);
    }

    componentDidUpdate() {
        this.checkAuth();
    }

    checkAuth = () => {
        if (!sessionStorage.getItem(SIGNIN_AUTH_TOKEN)) {
            this.props.navigate("/auth/login", { replace: true });
        }
    };

    startTimer = () => {
        this.setState({ timer: 60, canResend: false });
        this.timerInterval = setInterval(() => {
            this.setState((prevState) => {
                if (prevState.timer <= 1) {
                    clearInterval(this.timerInterval);
                    return { timer: 0, canResend: true };
                }
                return { timer: prevState.timer - 1 };
            });
        }, 1000);
    };

    handleChange = (index, value) => {
        // Only allow numbers
        if (value && !/^\d$/.test(value)) {
            return;
        }

        const newOtp = [...this.state.otp];
        newOtp[index] = value;
        this.setState({ otp: newOtp });

        // Auto-focus next input
        if (value && index < 5) {
            this.otpInputRefs[index + 1]?.focus();
        }
    };

    handleKeyDown = (index, e) => {
        // Handle backspace
        if (e.key === 'Backspace' && !this.state.otp[index] && index > 0) {
            this.otpInputRefs[index - 1]?.focus();
        }
    };

    handlePaste = (e) => {
        e.preventDefault();
        const pastedData = e.clipboardData.getData('text').trim();
        
        // Only process if it's 6 digits
        if (/^\d{6}$/.test(pastedData)) {
            const newOtp = pastedData.split('').slice(0, 6);
            this.setState({ otp: newOtp });
            // Focus last input
            this.otpInputRefs[5]?.focus();
        }
    };


    getUserDetails = () => {
        UserService.getuserdetails()
            .then((res) => {
                localStorage.setItem("profile", JSON.stringify(res));
                localStorage.setItem("accountId", res.accountId);
                localStorage.setItem("tenant", res.tenant);
                showNotificationGlobal("OTP verified successfully. Logging in...", "success");
                setTimeout(() => {
                    this.props.navigate("/apps");
                }, 1000);
            }).catch((error) => {

            })
    }


    moveToLogin = () => {
        this.props.navigate("/auth/login", {
            state: {
                showLoginForm: true,
                loginMethod: "auth0"
            }
        });
    }

    handleSubmit = async (e) => {
        e.preventDefault();
        const { otp, email } = this.state;
        const otpString = otp.join('');

        if(!email) {
            return this.moveToLogin();
        }
    
        if (otpString.length !== 6) {
            return showNotificationGlobal("Please enter all 6 digits", "error");
        }
    
        this.setState({ isLoading: true });
    
        const postData = { email, otp: otpString };
    
        try {
            const response = await LoginService.verifyOTP(postData);
    
            if (response.status !== API_RESPONSE.SUCCESS) {
                this.setState({ isLoading: false });
                return showNotificationGlobal(response.errorMessage || "Verification failed", "error");
            }
    
            // Store OTP valid session token
            sessionStorage.setItem(SIGNIN_AUTH_TOKEN, response?.authToken);
    
            const tenants = response?.accountsDTOS;
            if (!tenants || tenants.length === 0) {
                this.setState({ isLoading: false });
                return showNotificationGlobal(response.errorMessage || "No Account found", "error");
            }

            // Persist tenant list for in-app tenant switching later
            try {
                localStorage.setItem("tenantList", JSON.stringify(tenants));
                localStorage.setItem("loginEmail", email);
            } catch (e) {}
    
            // Multiple tenant case → Navigate to tenant selection
            if (tenants.length > 1) {
                this.setState({ isLoading: false });
                return this.props.navigate("/auth/tenants", {
                    state: { tenantList: tenants, email }
                });
            }
    
            // Single tenant
            const tenant = tenants[0];
            localStorage.setItem("accountLogo", tenant?.accountLogo);
            localStorage.setItem("accountName", tenant?.accountName);
    
            const tenantData = {
                email: email.toLowerCase(),
                authToken: sessionStorage.getItem(SIGNIN_AUTH_TOKEN),
                accountId: tenant?.accountID,
            };
    
            const validateResponse = await LoginService.validateAuth(tenantData);
    
            if (validateResponse.status !== API_RESPONSE.SUCCESS) {
                this.setState({ isLoading: false });
                return showNotificationGlobal(validateResponse.errorMessage || "Authentication failed", "error");
            }
    
            // Final login token + decode
            const decoded = jwtDecode(validateResponse.token);
            localStorage.setItem(ACCESS_TOKEN, validateResponse.token);
            localStorage.setItem("Uid", decoded?.id);
            if (decoded?.roles?.length > 0) {
                localStorage.setItem("role", decoded.roles[0]);
            }

            if (isDesktopOAuth()) {
                this.setState({ isLoading: false });
                showNotificationGlobal("Opening SuperAgentX Desktop…", "success");
                try {
                    await completeDesktopOAuth({
                        accessToken: validateResponse.token,
                        authorizeFn: (payload) => LoginService.authorizeDesktop(payload),
                    });
                } catch (err) {
                    showNotificationGlobal(
                        err?.message || "Could not return to SuperAgentX Desktop. Try again.",
                        "error"
                    );
                }
                return;
            }

            const restoreDesktop = preserveDesktopOAuthAcrossClear();
            sessionStorage.clear(); // OTP auth no longer needed
            restoreDesktop();
            this.setState({ isLoading: false });

            return this.getUserDetails();
        } catch (error) {
            this.setState({ isLoading: false });
            showNotificationGlobal(
                error?.response?.data?.errorMessage || "Invalid OTP. Please try again.",
                "error"
            );
        }
    };    

    handleResendOTP = async () => {
        if (!this.state.canResend) {
            return;
        }

        try {
            try {
                const response = await LoginService.auth(this.state.email);      
                // ✅ SUCCESS block
                if (response.status === API_RESPONSE.SUCCESS) {
                  sessionStorage.setItem(SIGNIN_AUTH_TOKEN, response.token);
                  showNotificationGlobal(messages.otpResentMessage, "success");
                  this.startTimer(); 
                }
                if (response.status === API_RESPONSE.FAILURE) {
                  return showNotificationGlobal(response.errorMessage, "error");
                }
      
              } catch (error) {
                showNotificationGlobal(error?.response?.data?.errorMessage || "Unexpected error occurred", "error");
              }

            
            // 
           
        } catch (error) {
            showNotificationGlobal(error?.response?.data?.errorMessage || "Failed to resend OTP. Please try again.", "error");
        }
    };

    formatTime = (seconds) => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins}:${secs.toString().padStart(2, '0')}`;
    };

    // ---- Showcase (right panel): rotating 3D carousel, same as the Sign in page ----
    // `turn` keeps counting up or down so the ring always spins the short way round
    getActive = () => {
        const n = this.slides.length;
        return ((this.state.turn % n) + n) % n;
    };

    goToSlide = (index) => this.setState((s) => {
        const n = this.slides.length;
        const active = ((s.turn % n) + n) % n;
        let delta = (((index - active) % n) + n) % n;
        if (delta > n / 2) delta -= n;
        return delta ? { turn: s.turn + delta } : null;
    });

    goToPrevious = () => this.setState((s) => ({ turn: s.turn - 1 }));
    goToNext = () => this.setState((s) => ({ turn: s.turn + 1 }));

    handleDragStart = (e) => {
        this.dragStart = e.clientX;
        this.dragged = false;
    };

    handleDragEnd = (e) => {
        if (this.dragStart == null) return;
        const dx = e.clientX - this.dragStart;
        this.dragStart = null;
        if (Math.abs(dx) > 50) {
            this.dragged = true;
            dx < 0 ? this.goToNext() : this.goToPrevious();
        }
    };

    // Mouse-follow tilt: writes CSS variables directly, so there is no re-render on mouse move
    handleStageMove = (e) => {
        const el = this.stageRef.current;
        if (!el) return;
        const r = el.getBoundingClientRect();
        const px = (e.clientX - r.left) / r.width - 0.5;
        const py = (e.clientY - r.top) / r.height - 0.5;
        el.style.setProperty('--ry', `${px * 8}deg`);
        el.style.setProperty('--rx', `${-py * 6}deg`);
    };

    handleStageLeave = () => {
        const el = this.stageRef.current;
        if (!el) return;
        el.style.setProperty('--ry', '0deg');
        el.style.setProperty('--rx', '0deg');
    };

    handleCardClick = (i) => {
        if (this.dragged) { this.dragged = false; return; }
        this.goToSlide(i);
    };

    renderShowcase = () => {
        const n = this.slides.length;
        const active = this.getActive();

        return (
            <div className="sx-content">
                <div className="sx-copy">
                    <h1 className="sx-title">
                        {HERO_TITLE.split(' ').map((w, i) => (
                            <span className="sx-word" key={i}>
                                <span className={i >= 4 ? 'sx-accent' : ''} style={{ '--i': i }}>{w}</span>
                            </span>
                        ))}
                    </h1>
                    <p className="sx-desc">{HERO_DESCRIPTION}</p>
                </div>

                <div
                    className="cv-wrap"
                    onMouseEnter={() => this.setState({ paused: true })}
                    onMouseLeave={() => { this.setState({ paused: false }); this.handleStageLeave(); }}
                >
                    <div
                        className="cv-stage"
                        ref={this.stageRef}
                        onMouseMove={this.handleStageMove}
                        onPointerDown={this.handleDragStart}
                        onPointerUp={this.handleDragEnd}
                        onPointerCancel={() => { this.dragStart = null; }}
                    >
                        {this.slides.map((s, i) => {
                            let off = (((i - active) % n) + n) % n;
                            if (off > n / 2) off -= n;
                            const hidden = Math.abs(off) > 1;
                            return (
                                <button
                                    type="button"
                                    key={i}
                                    className={`cv-card ${off === 0 ? 'is-front' : ''} ${hidden ? 'is-back' : ''}`}
                                    style={{ '--o': off }}
                                    onClick={() => this.handleCardClick(i)}
                                    aria-label={s.label}
                                    aria-current={off === 0}
                                    tabIndex={hidden ? -1 : 0}
                                >
                                    <span className="cv-bar"><i /><i /><i /></span>
                                    <img src={s.image} alt="" className="cv-img" draggable={false} />
                                </button>
                            );
                        })}

                        <button type="button" className="sx-arrow cv-arrow cv-arrow--prev" onClick={this.goToPrevious} aria-label="Previous slide">
                            <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
                        </button>
                        <button type="button" className="sx-arrow cv-arrow cv-arrow--next" onClick={this.goToNext} aria-label="Next slide">
                            <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { otp, timer, canResend, isLoading, email } = this.state;
        if (!sessionStorage.getItem(SIGNIN_AUTH_TOKEN)) {
            return null; // nothing renders
        }  
        return (
            <div className="auth-container auth-container--signin">
                {/* Main Content Area */}
                <div className="auth-main-content">
                    {/* Left Side - OTP Form */}
                    <div className="login-form">
                        <div className="login-form-content login-signin-card">
                            {/* Logo */}
                            <div className="login-logo-top">
                                <img src={logoBeta} alt="SuperAgentX Logo" className="login-logo-img" />
                            </div>
                            
                            <div className="login-header">
                                <div className="login-title">
                                    <h3 className="login-signin-card__heading font-bold mb-2">Verify Your Email</h3>
                                    <p className="login-signin-card__subtitle font-regular font13 mb-1">
                                        We sent a 6-digit verification code to
                                    </p>
                                    <p className="font-semi-bold font14 mb-4" style={{ color: '#0f2748' }}>
                                        {email || 'your email'}
                                    </p>
                                </div>
                            </div>
                            
                            <form onSubmit={this.handleSubmit} className="otp-form">
                                <div className="otp-input-container">
                                    {otp.map((digit, index) => (
                                        <input
                                            key={index}
                                            ref={(ref) => (this.otpInputRefs[index] = ref)}
                                            type="text"
                                            inputMode="numeric"
                                            maxLength="1"
                                            className="otp-input"
                                            value={digit}
                                            onChange={(e) => this.handleChange(index, e.target.value)}
                                            onKeyDown={(e) => this.handleKeyDown(index, e)}
                                            onPaste={index === 0 ? this.handlePaste : undefined}
                                            autoComplete="off"
                                        />
                                    ))}
                                </div>

                                <div className="otp-timer-container">
                                    {!canResend ? (
                                        <p className="otp-timer-text">
                                            Resend code in <span className="otp-timer">{this.formatTime(timer)}</span>
                                        </p>
                                    ) : (
                                        <button
                                            type="button"
                                            className="btn-resend-otp"
                                            onClick={this.handleResendOTP}
                                        >
                                            <i className="fas fa-redo-alt me-2"></i>
                                            Resend OTP
                                        </button>
                                    )}
                                </div>

                                <div className="form-actions mt-4">
                                    <button 
                                        className="btn btn-primary font-semi-bold w-100" 
                                        type="submit"
                                        disabled={isLoading || otp.join('').length !== 6}
                                    >
                                        {isLoading ? (
                                            <>
                                                <i className="fas fa-spinner fa-spin me-2"></i>
                                                Verifying...
                                            </>
                                        ) : (
                                            <>
                                                Verify OTP
                                                <i className="fas fa-arrow-right ms-2"></i>
                                            </>
                                        )}
                                    </button>
                                </div>

                                <div className="otp-help-text mt-3">
                                    <p className="font-regular font13 txt-grey-50 mb-0">
                                        Didn't receive the code? Check your spam folder or{' '}
                                        <button
                                            type="button"
                                            className="btn-link-otp"
                                            onClick={() => this.moveToLogin()}
                                        >
                                            Try another email
                                        </button>
                                    </p>
                                </div>
                            </form>
                            
                            <div className="login-footer">
                                <span style={{ color: '#64748b', fontSize: '13px', fontWeight: '400' }}>
                                    © {getYear()} SuperAgentX • Version {APP_VERSION}
                                </span>
                            </div>
                        </div>
                    </div>

                    {/* Right Side - Animated Showcase (same as the Sign in page) */}
                    <div className={`auth-banner sx-stage ${this.state.paused ? 'is-paused' : ''}`}>
                        <div className="sx-aurora" aria-hidden="true">
                            <span className="sx-orb sx-orb--a" />
                            <span className="sx-orb sx-orb--b" />
                            <span className="sx-orb sx-orb--c" />
                            <span className="sx-grid" />
                        </div>
                        {this.renderShowcase()}
                    </div>
                </div>
            </div>
        );
    }
}

export default withNavigate(OTPVerification);